import { useEffect } from 'react';
import { useDeepCompareEffect } from 'react-use';
import { useAppSelector } from 'app-components/hooks/redux';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

type GlobalHotKey = {
  code: string;

  shiftKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;

  description: string;
  callback: () => void;
  context?: string;
};
const globalHotKeys: GlobalHotKey[] = [];

export const useGlobalHotKey = (globalHotKey: GlobalHotKey) => {
  useDeepCompareEffect(() => {
    globalHotKeys.push(globalHotKey);
    return () => {
      const index = globalHotKeys.indexOf(globalHotKey);
      if (index !== -1) {
        globalHotKeys.splice(index, 1);
      }
    };
  }, [globalHotKey]);
};

const GlobalHotKeys = () => {
  const globalHotKeysEnabled = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'globalHotKeys'));
  useEffect(() => {
    if (globalHotKeysEnabled) {
      const handleKeyDown = (event: KeyboardEvent) => {
        globalHotKeys.forEach((hotKey) => {
          if (
            event.code === hotKey.code &&
            Boolean(event.shiftKey) === Boolean(hotKey.shiftKey) &&
            Boolean(event.ctrlKey) === Boolean(hotKey.ctrlKey) &&
            Boolean(event.altKey) === Boolean(hotKey.altKey) &&
            Boolean(event.metaKey) === Boolean(hotKey.metaKey)
          ) {
            if (hotKey.callback) {
              event.preventDefault();
              hotKey.callback();
            }
          }
        });
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    return undefined;
  }, [globalHotKeysEnabled]);

  return null;
};

export default GlobalHotKeys;
